/* eslint-disable */
// export const BASE_URL = 'http://localhost/genx_apis/public/'
export const BASE_URL = 'https://genx.dkinfoway.com/apis/public/'
// export const BASE_URL = 'https://bluemoonapi.dkinfoway.com/'
// export const BASE_URL = 'http://127.0.0.1:8000/api'
